<ce-layout [showLayout]="showLayout" [showGlobalLoading]="showRouteLoading">
    <!-- Cookie banner -->
    <ce-cookie-banner></ce-cookie-banner>

    <!-- Page content -->
    <router-outlet></router-outlet>

    <!-- Dialog 1 -->
    <router-outlet name="d"></router-outlet>
    <!-- Dialog 2 -->
    <router-outlet name="d2"></router-outlet>
</ce-layout>
